import { IconAdjustments, IconLogout, IconUserEdit } from "@tabler/icons-react"
import type { MenuItem } from "@tfg/ui"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import { useAuth } from "~/store/auth-context"
import { useMantineTheme } from "@mantine/core"

export const useSupplierUserMenuItems = (): MenuItem[] => {
  const { t, i18n } = useTranslation()
  const { logout, isAdmin } = useAuth()
  const navigate = useNavigate()
  const theme = useMantineTheme()

  const menuItems: MenuItem[] = [
    {
      label: t("menus.profile"),
      icon: <IconUserEdit size={theme.other.icon.size} />,
      isActive: false,
      onClick: () => navigate("/profile"),
    },
    {
      label: t("menus.logout"),
      icon: <IconLogout size={theme.other.icon.size} />,
      isActive: false,
      onClick: () => logout(),
    },
  ]

  const adminItem: MenuItem | null = isAdmin
    ? {
        label: i18n.t("menus.admin"),
        icon: <IconAdjustments size={theme.other.icon.size} />,
        isActive: false,
        onClick: () => navigate("/admin"),
      }
    : null

  if (adminItem) menuItems.splice(-1, 0, adminItem)

  return menuItems
}
